var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF3432A2-95BE-4744-84B8-DED3467EBC1D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BusinessAdmin---Events",
    transform: "translate(-584.000000, -722.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(584.000000, 722.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-3",
    transform: "translate(19.000000, 19.000000) rotate(-360.000000) translate(-19.000000, -19.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF",
    x: 5.68434189e-14,
    y: 0,
    width: 38,
    height: 38,
    rx: 19
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ar-right",
    fill: "#2BAFD8",
    fillRule: "nonzero",
    transform: "translate(17.931607, 19.000000) rotate(-180.000000) translate(-17.931607, -19.000000) ",
    points: "19.726427 19 13.8632135 13.1367865 15 12 22 19 15 26 13.8632135 24.8632135"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeft);
export default __webpack_public_path__ + "static/media/PaginationLeft.01a829bfa87b419b63b477ff402b6b50.svg";
export { ForwardRef as ReactComponent };